"use strict";

exports.__esModule = true;
var _MeasurementValue = require("./MeasurementValue");
Object.keys(_MeasurementValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MeasurementValue[key]) return;
  exports[key] = _MeasurementValue[key];
});